'use client';

import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { RootState } from '@/components/default/redux/store';
// import FBSettingsService from '../../services/api/dashboard/fb.service';
const Root = dynamic(() => import('@/components/default/views/root/Root'), { ssr: false });
const Home = dynamic(() => import('@/components/default/views/home/Home'), { ssr: false });
// import sha256 from 'crypto-js/sha256';
import { useEffect } from 'react';

export default function RootViewPage() {
    const domainType = useSelector((state: RootState) => state.domain.domainType);

    const loadHomePage = (domainType: string) => {
        switch (domainType) {
            case 'main':
                return <Root />;
            case 'sub':
                return <Home />;
            case 'custom':
                return <Home />;
            default:
                return null;
        }
    };

    useEffect(() => {
        // 1️⃣ PageView (auto-tracked, but can also call manually)
        (window as any).sendFBEvent?.('PageView');
    }, []);

    return (
        <>
            {/* <div className="flex gap-3">
                <button
                    onClick={() => {
                        window.sendFBEvent?.('CompleteRegistration', { value: 0, currency: 'USD' }, 'user@example.com');
                    }}
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                    Submit Register
                </button>

                <button
                    onClick={() => {
                        window.sendFBEvent?.('AddToCart', { content_name: 'Product A', value: 100, currency: 'USD' }, 'user@example.com');
                    }}
                    className="bg-green-600 text-white px-4 py-2 rounded"
                >
                    Add to Cart
                </button>

                <button
                    onClick={() => {
                        window.sendFBEvent?.('Purchase', { content_name: 'Product A', value: 100, currency: 'USD' }, 'user@example.com');
                    }}
                    className="bg-purple-600 text-white px-4 py-2 rounded"
                >
                    Complete Order
                </button>
            </div> */}

            {/* Push content down so it doesn't hide under the top bar */}
            <div>
                {/* Render the Root component only if domainType is not null */}
                {
                    domainType && loadHomePage(domainType) // Function to load the home page based on domain type
                }
            </div>
        </>
    );
}
